import restful from '@/utils/restful';
import * as names from '@/store/names';
import * as get from '@/store/store';

// Tipos de sala: catálogo institucional que se asigna por División de tiempo (Carga Académica).
const state = {
    classroom_types: [],
    classroom_types_url: '/mesh/classroom-type'
}

const getters = {
    [names.CLASSROOM_TYPES]: state => {
        if (!get.store.state.user) return [];
        return state.classroom_types
            .filter((x) => x.school == get.store.state.user.school)
            .sort((a, b) => a.order - b.order || a.id - b.id);
    },
}
const mutations = {
    [names.MUTATE_CLASSROOM_TYPES]: (state, classroom_types) => {
        classroom_types.forEach(element => {
            let index = state.classroom_types.findIndex(x => x.id == element.id);
            if (index != -1) state.classroom_types.splice(index, 1, element);
            else state.classroom_types.push(element);
        });
    },
    [names.MUTATE_CLASSROOM_TYPE]: (state, classroom_type) => {
        let index = state.classroom_types.findIndex(x => x.id == classroom_type.id);
        if (index != -1) state.classroom_types.splice(index, 1, classroom_type);
        else state.classroom_types.push(classroom_type);
    },
    [names.MUTATE_DELETE_CLASSROOM_TYPE]: (state, classroom_type_id) => {
        let index = state.classroom_types.findIndex(x => x.id == classroom_type_id);
        if (index != -1) state.classroom_types.splice(index, 1);
    },
}
const actions = {
    [names.FETCH_CLASSROOM_TYPES]: ({
        commit,
        state
    }, force) => {
        return new Promise((resolve) => {
            if (!force && state.classroom_types.length > 0) {
                resolve(state.classroom_types);
                return;
            }
            restful.GetAll(`${state.classroom_types_url}/`)
                .then(response => {
                    commit(names.MUTATE_CLASSROOM_TYPES, response);
                    resolve(response);
                });
        });
    },
    [names.POST_CLASSROOM_TYPE]: ({
        commit,
        state
    }, classroom_type) => {
        // Rechaza si falla, para que el formulario vuelva a habilitar el botón Guardar
        return new Promise((resolve, reject) => {
            restful.Post(`${state.classroom_types_url}/`, classroom_type)
                .then(response => {
                    commit(names.MUTATE_CLASSROOM_TYPE, response);
                    resolve(response);
                })
                .catch(reject);
        });
    },
    [names.PATCH_CLASSROOM_TYPE]: ({
        commit,
        state
    }, payload) => {
        return new Promise((resolve, reject) => {
            restful.Patch(`${state.classroom_types_url}/${payload.classroom_type_id}/`, payload.item)
                .then(response => {
                    commit(names.MUTATE_CLASSROOM_TYPE, response);
                    resolve(response);
                })
                .catch(reject);
        });
    },
    [names.DELETE_CLASSROOM_TYPE]: ({
        commit,
        state
    }, classroom_type_id) => {
        return new Promise((resolve) => {
            restful.Delete(`${state.classroom_types_url}/${classroom_type_id}/`)
                .then(response => {
                    commit(names.MUTATE_DELETE_CLASSROOM_TYPE, classroom_type_id);
                    resolve(response);
                });
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
};
